import styled from 'styled-components';
import media from '../../constants/media';
import {asHeading3, H2} from "../base/typography";

export const Wrapper = styled.div`
	margin: 6rem 0;
	overflow-x: auto;
	overflow-y: visible;

	${media.desktopSmall`
		margin: 12rem 0;
	`}
`;

export const Heading = styled(H2)`
	${asHeading3};
	margin-bottom: 3rem;
`;